import { useState } from 'react';

import { useSelector } from 'react-redux';
import { usePermission } from '../../../../hooks/usePermission';
import { accountSelector, authSelector } from '../../../../store';
import { navItemObjects, sageAdminNavItemObjects } from '../../NavConstant';
import SidebarNavHeader from '../../SibarNavHeader';
import SidebarNavFooter from '../../SidebarNavFooter';
import NavItem from '../NavItem';

export default function BigScreenNav() {
  const { data: accountInfo } = useSelector(accountSelector);
  const { data: currentUserData } = useSelector(authSelector);
  const [isFullNavHidden, setIsFullNavHidden] = useState(false);
  const navItems = currentUserData.account === 'sageadmin' ? sageAdminNavItemObjects : navItemObjects;

  const navToggleHandler = () => {
    setIsFullNavHidden((prevState) => !prevState);
  };
  const { hasNavAccess } = usePermission();
  return (
    <div
      className={`hidden flex flex-col ${
        isFullNavHidden ? 'w-20' : 'w-80'
      } lg:flex lg:shrink-0 h-screen min-h-0 overflow-hidden border-r border-gray-200 transition transition-width duration-200 ease-in-out`}
    >
      <div className='shrink-0 pt-5'>
        <SidebarNavHeader isFullNavHidden={isFullNavHidden} navToggleHandler={navToggleHandler} />
      </div>
      <nav className='mt-5 min-h-0 flex-1 w-full overflow-y-auto pb-4' aria-label='Sidebar'>
        <div className='px-2 space-y-1'>
          {navItems.map((item) => {
            const { permissions, roles, name, subscription, requiresSystemAdmin } = item;
            if (hasNavAccess(permissions, roles, requiresSystemAdmin)) {
              if (subscription && !accountInfo?.subscriptions.includes(subscription)) {
                return null;
              }
              return (
                <NavItem
                  key={name}
                  item={currentUserData.account === 'birminghamhousing' && item.path === 'company' ? { ...item, path: 'company' } : item}
                  isFullNavHidden={isFullNavHidden}
                />
              );
            }
            return null;
          })}
        </div>
      </nav>
      <footer className='shrink-0'>
        <SidebarNavFooter setIsFullNavHidden={navToggleHandler} isFullNavHidden={isFullNavHidden} />
      </footer>
    </div>
  );
}
